import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Label,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import moment from 'moment'

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear + 3 ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}

const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

class IndexView extends Component {

    createBloc = new CreateBloc();
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            monthOptions: createMonthOptions(),
            rankOption: [],
            echelonOption: [],
            empOption: [],
            empOptionValuer: [],
            empOptionAtasan: [],
            empOptionPosition: [],
            empOptionWorkunit: [],
            empOptionPositionHistory: [],
            empOptionRankGroup: [],
            jabatanPenilai:'',
            jabatanPenilai_uuid:'',
            jabatanAtasan:'',
            jabatanAtasan_uuid:'',
            workunitPenilai:'',
            workunitPenilai_uuid:'',
            workunitAtasan:'',
            workunitAtasan_uuid:'',
            unit_detail_valuer_uuid:'',
            unit_detail_valuer_name:'',
            unit_detail_boss_uuid:'',
            unit_detail_boss_name:'',
            penilai: {},
            atasan:{},
            emp_pos_name:'',
            emp_pos_uuid:'',
            emp_pos_unit_name:'',
            emp_pos_unit_uuid:'',
            employee_rank_name:'',
            valuer_rank_name:'',
            atasan_rank_name:'',
            jenisSKPOption: [
                { label: "PP No.30 Tahun 2019", value: 1 },
                { label: "PERMENPAN RB No.8 Tahun 2021", value: 2 }
            ],
        }
    }

    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_detail = !accessRole('approve') ? (this.userdata != null ? this.userdata : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted : "")

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, '') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
        console.log(formData)
    }

    handlerOnSubmit = (e, values) => {
        console.log(values)
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    get_employee = (e) => {
        // alert(e.value)
        this.createBloc.fetcEmployee({uuid: e.value })
    }
    get_atasan = (e) => {
        // alert(e.value)
        this.createBloc.fetcAtasan({uuid: e.value })
    }
    set_jabatanPepegawai = (e) => {
        let value = e.value
        let label = e.label
        // alert(label)
        this.createBloc.fetchPositionHistoryDetail({uuid: accessRole('approve')? this.queryParams.get('euuid') : this.peg_detail?.employee_uuid,posuuid:value})
        this.setState({
            emp_pos_name: label,
            emp_pos_uuid: value,
        })
    }
    set_jabatanPenilai = (e) => {
        let value = e.value
        let label = e.label
        // alert(label)
        this.createBloc.fetchPositionUnitvaluer({posuuid:value})
        this.setState({
            jabatanPenilai: label,
            jabatanPenilai_uuid: value,
        })
    }
    set_jabatanAtasan = (e) => {
        if(e){
            let value = e.value
            let label = e.label
            this.createBloc.fetchPositionUnitboss({posuuid:value})
            this.setState({
                jabatanAtasan: label,
                jabatanAtasan_uuid: value,
            })
        }
    }
    set_unitPenilai = (e) => {
        let value = e.value
        let label = e.label
        // alert(label)
        this.setState({
            workunitPenilai: label,
            workunitPenilai_uuid: value,
        })
    }
    set_unitAtasan = (e) => {
        if(e){
            let value = e.value
            let label = e.label
            this.setState({
                workunitAtasan: label,
                workunitAtasan_uuid: value,
            })
        }
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        document.getElementById("skp_header_start_date").defaultValue = "2014-02-09";
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:

                    if (result.data.status){
                        this.setState({
                            loading: false,
                            success: true
                        });
                    } else {
                        this.setState({
                            loading: false,
                            message: result.data.message,
                            failed: true
                        });
                    }

                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.initialHeaderChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_employee = result.data.response
                        console.log(response_employee)
                        this.setState({
                            detail_employee: response_employee,
                            emp_pos_name: response_employee?.employee?.employee_current_position_name,
                            emp_pos_uuid: response_employee?.employee?.employee_current_position_uuid,
                            emp_pos_unit_name: response_employee?.employee?.work_unit_name,
                            emp_pos_unit_uuid: response_employee?.employee?.employee_current_work_unit_uuid,
                            jabatanPenilai: response_employee?.valuer?.employee_current_position_name,
                            jabatanPenilai_uuid: response_employee?.valuer?.employee_current_position_uuid,
                            jabatanAtasan: response_employee?.atasan?.employee_current_position_name,
                            jabatanAtasan_uuid: response_employee?.atasan?.employee_current_position_uuid,
                            workunitPenilai: response_employee?.valuer?.work_unit_name,
                            workunitPenilai_uuid: response_employee?.valuer?.work_unit_uuid,
                            workunitAtasan: response_employee?.atasan?.work_unit_name,
                            workunitAtasan_uuid: response_employee?.atasan?.work_unit_uuid
                        })
                        // console.log('this.state.detail_employee')
                        // console.log(this.state.detail_employee)
                        this.createBloc.fetcOptEmployeePenilai({echelon_name: response_employee?.valuer?.echelon_name })
                        this.createBloc.fetcEmployee({uuid: response_employee?.valuer?.employee_uuid })
                        this.createBloc.fetcAtasan({uuid: response_employee?.atasan?.employee_uuid })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.positionHistoryDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            // emp_pos_unit_name: response.position_history_work_unit_to_name,
                            // emp_pos_unit_uuid: response.position_history_work_unit_uuid_to
                           emp_pos_unit_name: response.work_unit_name,
                           emp_pos_unit_uuid: response.work_unit_uuid
                        })
                        
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.positionUnitValuerDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            // emp_pos_unit_name: response.position_history_work_unit_to_name,
                            // emp_pos_unit_uuid: response.position_history_work_unit_uuid_to
                           unit_detail_valuer_name: response.work_unit_name,
                           unit_detail_valuer_uuid: response.work_unit_uuid
                        })
                        
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.positionUnitbossDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            // emp_pos_unit_name: response.position_history_work_unit_to_name,
                            // emp_pos_unit_uuid: response.position_history_work_unit_uuid_to
                           unit_detail_boss_name: response.work_unit_name,
                           unit_detail_boss_uuid: response.work_unit_uuid
                        })
                        
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.rankChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    // console.log(result.data.response.result)
                    this.setState({ 
                        rankOption: result.data.response.result.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.rank_group_room;
                            newObj["value"] = data.rank_uuid;
                            
                            return newObj;
                        }), 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });

        this.createBloc.echelonChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        echelonOption: result.data.response.result.map(function(data) {
                            var newObj = {};
                            newObj["label"] = `${data.echelon_name}`;
                            newObj["value"] = data.echelon_name;
                        
                            return newObj;
                          }), 
                        loadingEchelon: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        this.createBloc.employeeOptChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    // console.log(result.data.response.result)
                    this.setState({ 
                        empOption: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.employee_full_name;
                            newObj["value"] = data.employee_uuid;
                            
                            return newObj;
                        }), 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        this.createBloc.employeeValuerOptChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    
                    this.createBloc.fetcOptEmployeeAtasan({echelon_name: this.state.detail_employee?.atasan?.echelon_name })
                    this.setState({ 
                        empOptionValuer: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.employee_full_name;
                            newObj["value"] = data.employee_uuid;
                            
                            return newObj;
                        }), 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        this.createBloc.employeeAtasanOptChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        empOptionAtasan: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.employee_full_name;
                            newObj["value"] = data.employee_uuid;
                            
                            return newObj;
                        }), 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_employee = result.data.response
                        this.setState({
                            penilai: response_employee
                        })
                        // console.log(this.state.emptype.toLowerCase())
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.atasanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_employee = result.data.response
                        this.setState({
                            atasan: response_employee
                        })
                        console.log(this.state.atasan)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.positionHistoryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let positionhistory = [];
                    // console.log('position history')
                    // console.log(result.data.response)
                    if (result.data.status) {
                        positionhistory = result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.position_history_position_name;
                            newObj["value"] = data.position_history_position_uuid;
                            
                            return newObj;
                        })
                    }

                    this.setState({ 
                        empOptionPositionHistory: positionhistory, 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        
        this.createBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let position = [];

                    if (result.data.status) {
                        position = result.data.response.result.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.position_name;
                            newObj["value"] = data.position_uuid;
                            
                            return newObj;
                        })
                    }

                    this.setState({ 
                        empOptionPosition: position, 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        this.createBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let unit = [];

                    if (result.data.status) {
                        unit = result.data.response.result.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.work_unit_name;
                            newObj["value"] = data.work_unit_uuid;
                            
                            return newObj;
                        })
                    }

                    this.setState({ 
                        empOptionWorkunit: unit, 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        // this.createBloc.rankGroupChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             let rankGroup = [];

        //             if (result.data.status) {
        //                 rankGroup = result.data.response.result.map(function(data) {
        //                     var newObj = {};
        //                     newObj["label"] = data.rank_group_room;
        //                     newObj["value"] = data.rank_group_room;
                            
        //                     return newObj;
        //                 })
        //             }

        //             this.setState({ 
        //                 empOptionRankGroup: rankGroup, 
        //                 loadingRank: false })
        //             break;
        //         case apiResponse.ERROR:
        //             break;
        //         default:
        //             break;
        //     }
        // });
        
        
        // console.log(this.queryParams.get('euuid'))
        this.createBloc.fetchRank()
        this.createBloc.fetchPosition({})
        this.createBloc.fetchPositionHistory({uuid: accessRole('approve')? this.queryParams.get('euuid') : this.peg_detail?.employee_uuid})
        this.createBloc.fetchWorkUnit({})
        this.createBloc.fetchEchelon()
        this.createBloc.fetchInitialHeader({employee_uuid: accessRole('approve')? this.queryParams.get('euuid') : this.peg_detail?.employee_uuid })
        this.createBloc.fetcOptEmployee({uuid: this.queryParams.get('euuid') })
        // this.createBloc.fetcRankGroup({ })
        
    }

    componentWillUnmount(){
        this.createBloc.createChannel.unsubscribe()
        this.createBloc.initialHeaderChannel.unsubscribe()
        this.createBloc.positionChannel.unsubscribe()
        this.createBloc.positionHistoryChannel.unsubscribe()
        this.createBloc.positionHistoryDetailChannel.unsubscribe()
        this.createBloc.rankGroupChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Periode SKP</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Pilih SKP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                            
                                                <CustomSelect 
                                                    name="skp_type"
                                                    errorMessage="Pilih SKP"
                                                    options={this.state.jenisSKPOption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih SKP"
                                                    defaultValue={1}
                                                    // onChange={opt => this.setState({ skptype: opt.value })}
                                                /> 
                                               
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Tahun <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="skp_header_year"
                                                    errorMessage="Pilih Tahun"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun"
                                                    defaultValue={new Date().getFullYear()}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Tanggal Mulai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="skp_header_start_date"
                                                    placeholder="Tanggal Mulai..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_header_start_date"
                                                    value={(new Date().getFullYear())+"-01-01"}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Tanggal Selesai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                            <AvField
                                                    name="skp_header_end_date"
                                                    placeholder="Tanggal Selesai..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skp_header_end_date"
                                                    value={(new Date().getFullYear())+"-12-31"}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-2 col-form-label"
                                            >
                                            Keterangan 
                                            </label>
                                            <Col md="6">
                                                 <AvField
                                                    name="skp_header_note"
                                                    id="skp_header_note"
                                                    placeholder="Keterangan"
                                                    type="textarea"
                                                    errorMessage="Masukan Keterangan"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                />
                                            </Col>
                                        </Row>          

                                        <hr />  

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            #Pegawai yang dinilai
                                            </label>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-2 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_nip_"
                                                    id="skp_header_employee_nip"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.detail_employee?.employee?.employee_nip}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_uuid"
                                                    readonly="readonly"
                                                    type="hidden"
                                                    value={this.state.detail_employee?.employee?.employee_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-2 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_name"
                                                    id="skp_header_employee_name"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.detail_employee?.employee?.employee_full_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Pangkat / Golongan  <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <CustomSelect 
                                                    name="skp_period_employee_rank_uuid"
                                                    errorMessage="Pilih Pangkat / Golongan "
                                                    placeholder="Pilih Pangkat / Golongan "
                                                    options={this.state.rankOption}
                                                    onChange={opt => this.setState({ employee_rank_name: opt.label })}
                                                    defaultValue={this.state.detail_employee?.employee?.employee_current_rank_uuid}
                                                    validate={{ required: { value: true } }}
                                                    readonly="true"
                                                />
                                                {/* <AvField
                                                    placeholder=""
                                                    name="employee_current_rank_name"
                                                    id="employee_current_rank_name"
                                                    type="text"
                                                    value={this.state.detail_employee?.employee?.employee_current_rank_name}
                                                    readonly="readonly"
                                                /> */}
                                                <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_rank"
                                                    id="skp_header_employee_rank"
                                                    type="hidden"
                                                    value={(this.state.employee_rank_name)?this.state.employee_rank_name:this.state.detail_employee?.employee?.rank_group_room}
                                                />
                                                {/* <AvField
                                                    placeholder=""
                                                    name="skp_period_employee_rank_uuid"
                                                    id="skp_period_employee_rank_uuid"
                                                    type="hidden"
                                                    value={this.state.detail_employee?.employee?.employee_current_rank_uuid}
                                                /> */}
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Eselon  <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_echelon"
                                                    id="skp_header_employee_echelon"
                                                    type="text"
                                                    value={this.state.detail_employee?.employee?.echelon_name}
                                                    readonly="readonly"
                                                />
                                                
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-2 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="jabatan_;pegawai"
                                                    errorMessage="Pilih Jabatan"
                                                    // options={this.state.empOptionPositionHistory} 
                                                    options={this.state.empOptionPosition} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pejabat Penilai"
                                                    defaultValue={this.state.emp_pos_uuid}
                                                    onChange={(e)=>this.set_jabatanPepegawai(e)}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_position"
                                                    id="skp_header_employee_position"
                                                    readonly="readonly"
                                                    type="hidden"
                                                    className="form-control"
                                                    value={this.state.emp_pos_name}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="skp_period_employee_position_uuid"
                                                    id="skp_period_employee_position_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    value={this.state.emp_pos_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-2 col-form-label"
                                            >
                                            Unit Kerja
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_work_unit"
                                                    id="skp_header_employee_work_unit"
                                                    readonly="readonly"
                                                    // type="textarea"
                                                    type="hidden"
                                                    className="form-control"
                                                    value={this.state.emp_pos_unit_name}
                                                />
                                                {/* <AvField
                                                    placeholder=""
                                                    name="skp_header_employee_work_unit_uuid"
                                                    readonly="readonly"
                                                    type="hidden"
                                                    value={this.state.emp_pos_unit_uuid}
                                                /> */}
                                                <CustomSelect 
                                                        name="skp_header_employee_work_unit_uuid"
                                                        errorMessage="Pilih Unit Kerja"
                                                        options={this.state.empOptionWorkunit} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih Unit Kerja"
                                                        defaultValue={this.state.emp_pos_unit_uuid}
                                                        onChange={(e)=>this.change_unit(e)}
                                                    />
                                            </Col>
                                        </Row>

                                        <hr />  

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            #Pejabat penilai
                                            </label>
                                        </Row>
                                        
                                        
                                        <>
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="no_sk"
                                                    className="col-md-2 col-form-label"
                                                >
                                                Pilih Pejabat Penilai <span className="text-danger">*</span>
                                                </label>
                                                <Col md="6">
                                                    <CustomSelect 
                                                        name="penilai"
                                                        errorMessage="Pilih Pejabat Penilai"
                                                        options={this.state.empOptionValuer} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih Pejabat Penilai"
                                                        defaultValue={this.state.detail_employee?.valuer?.employee_uuid}
                                                        onChange={(e)=>this.get_employee(e)}
                                                    />
                                                </Col>
                                            </Row> 

                                            <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                NIP 
                                                </label>
                                                <Col md="3">
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_nip_"
                                                        id="skp_header_valuer_employee_nip"
                                                        readonly="readonly"
                                                        type="form-control"
                                                        className="form-control"
                                                        value={this.state.penilai?.employee_nip}
                                                    />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_uuid"
                                                        type="hidden"
                                                        value={this.state.penilai?.employee_uuid}
                                                    />
                                                </Col>
                                            </Row>
                                            
                                            {/* <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                Nama 
                                                </label>
                                                <Col md="3"> */}
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_name"
                                                        id="skp_header_valuer_employee_name"
                                                        readonly="readonly"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.penilai?.employee_full_name}
                                                    />
                                                {/* </Col>
                                            </Row> */}

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Pangkat / Golongan  <span className="text-danger">*</span>
                                                </Label>
                                                <Col md="3">
                                                    <CustomSelect 
                                                        name="skp_period_boss_employee_rank_uuid"
                                                        errorMessage="Pilih Pangkat / Golongan "
                                                        placeholder="Pilih Pangkat / Golongan "
                                                        options={this.state.rankOption}
                                                        onChange={opt => this.setState({ valuer_rank_name: opt.label })}
                                                        defaultValue={this.state.penilai?.employee_rank_uuid}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                        {/* <AvField
                                                            placeholder=""
                                                            name="employee_current_rank_name"
                                                            id="employee_current_rank_name"
                                                            type="text"
                                                            value={this.state.penilai?.employee_rank_group_room}
                                                            readonly="readonly"
                                                        />
                                                    */}
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_rank"
                                                        id="skp_header_valuer_employee_rank"
                                                        type="hidden"
                                                        value={(this.state.valuer_rank_name)?this.state.valuer_rank_name:this.state.penilai?.employee_rank_group_room}
                                                    /> 
                                                    {/* <AvField
                                                        placeholder=""
                                                        name="skp_period_boss_employee_rank_uuid"
                                                        id="skp_period_boss_employee_rank_uuid"
                                                        type="hidden"
                                                        value={this.state.penilai?.employee_current_rank_uuid}
                                                    /> */}
                                                </Col>
                                            </Row>

                                            {/* <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Eselon  <span className="text-danger">*</span>
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_echelon"
                                                        id="skp_header_valuer_employee_echelon"
                                                        readonly="readonly"
                                                        type="form-control"
                                                        className="form-control"
                                                        value={this.state.penilai?.echelon_name}
                                                    />
                                                </Col>
                                            </Row> */}

                                            <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                Jabatan 
                                                </label>
                                                <Col md="6">
                                                <CustomSelect 
                                                        name="penilai"
                                                        errorMessage="Pilih Jabatan"
                                                        options={this.state.empOptionPosition} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih Jabatan"
                                                        defaultValue={this.state.detail_employee?.valuer?.employee_current_position_uuid}
                                                        onChange={(e)=>this.set_jabatanPenilai(e)}
                                                    />
                                                    <br />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_position"
                                                        id="skp_header_valuer_employee_position"
                                                        // readonly="readonly"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.jabatanPenilai}
                                                    />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_period_boss_employee_position_uuid"
                                                        id="skp_period_boss_employee_position_uuid"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.jabatanPenilai_uuid}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                Unit Kerja
                                                </label>
                                                <Col md="6">
                                                <CustomSelect 
                                                        name="penilai_unit"
                                                        errorMessage="Pilih Unit Kerja"
                                                        options={this.state.empOptionWorkunit} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih Unit Kerja"
                                                        defaultValue={(this.state.unit_detail_valuer_uuid)?this.state.unit_detail_valuer_uuid:this.state.detail_employee?.valuer?.work_unit_uuid}
                                                        onChange={(e)=>this.set_unitPenilai(e)}
                                                    />
                                                    <br />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_work_unit"
                                                        id="skp_header_valuer_employee_work_unit"
                                                        // readonly="readonly"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.workunitPenilai}
                                                    />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_valuer_employee_work_unit_uuid"
                                                        readonly="readonly"
                                                        type="hidden"
                                                        value={this.state.workunitPenilai_uuid}
                                                    />
                                                </Col>
                                            </Row>
                                        </> 
                                        

                                        <hr />  

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            #Atasan Pejabat penilai
                                            </label>
                                        </Row>

                                        <>
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="no_sk"
                                                    className="col-md-2 col-form-label"
                                                >
                                                Pilih Atasan Pejabat Penilai <span className="text-danger">*</span>
                                                </label>
                                                <Col md="6">
                                                    <CustomSelect 
                                                        name="atasan"
                                                        errorMessage="Pilih Atasan Pejabat Penilai"
                                                        options={this.state.empOption} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih Ataasan Pejabat Penilai"
                                                        defaultValue={this.state.detail_employee?.atasan?.employee_uuid}
                                                        onChange={(e)=>this.get_atasan(e)}
                                                    />
                                                </Col>
                                            </Row> 
                                            <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                NIP 
                                                </label>
                                                <Col md="3">
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_nip"
                                                        id="skp_header_employee_nip"
                                                        readonly="readonly"
                                                        type="form-control"
                                                        className="form-control"
                                                        value={this.state.atasan?.employee_nip}
                                                    />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_uuid_"
                                                        readonly="readonly"
                                                        type="hidden"
                                                        value={this.state.atasan?.employee_uuid}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                Nama 
                                                </label>
                                                <Col md="3"> */}
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_name"
                                                        id="skp_header_head_valuer_employee_name"
                                                        readonly="readonly"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.atasan?.employee_full_name}
                                                    />
                                                {/* </Col>
                                            </Row> */}

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Pangkat / Golongan  <span className="text-danger">*</span>
                                                </Label>
                                                <Col md="3">
                                                    <CustomSelect 
                                                        name="skp_period_head_boss_employee_rank_uuid"
                                                        errorMessage="Pilih Pangkat / Golongan "
                                                        placeholder="Pilih Pangkat / Golongan "
                                                        options={this.state.rankOption}
                                                        onChange={opt => this.setState({ atasan_rank_name: opt.label })}
                                                        defaultValue={this.state.atasan.employee_rank_uuid}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                    {/* <AvField
                                                            placeholder=""
                                                            name="employee_current_rank_name"
                                                            id="employee_current_rank_name"
                                                            type="text"
                                                            value={this.state.atasan?.employee_rank_group_room}
                                                            readonly="readonly"
                                                        />
                                                    */}
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_rank"
                                                        id="skp_header_head_valuer_employee_rank"
                                                        type="hidden"
                                                        value={(this.state.atasan_rank_name)?this.state.atasan_rank_name:this.state.atasan.employee_rank_group_room}
                                                    />
                                                    {/* <AvField
                                                        placeholder=""
                                                        name="skp_period_head_boss_employee_rank_uuid"
                                                        id="skp_period_head_boss_employee_rank_uuid"
                                                        type="hidden"
                                                        value={this.state.atasan?.employee_current_rank_uuid}
                                                    /> */}
                                                </Col>
                                            </Row>

                                            {/* <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Eselon  <span className="text-danger">*</span>
                                                </Label>
                                                <Col md="3"> */}
                                                    {/* <CustomSelect 
                                                        name="skp_header_head_valuer_employee_echelon"
                                                        errorMessage="Pilih Eselon "
                                                        placeholder="Pilih Eselon "
                                                        options={this.state.echelonOption}
                                                        //onChange={opt => this.setState({ type: opt.value })}
                                                        defaultValue={this.state.atasan.echelon_name}
                                                        validate={{ required: { value: true } }}
                                                    /> */}
                                                    {/* <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_echelon"
                                                        id="skp_header_head_valuer_employee_echelon"
                                                        readonly="readonly"
                                                        type="form-control"
                                                        className="form-control"
                                                        value={this.state.atasan?.echelon_name}
                                                    />
                                                </Col>
                                            </Row> */}

                                            <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                Jabatan 
                                                </label>
                                                <Col md="6">
                                                <CustomSelect 
                                                        name="atasan_jabatan"
                                                        errorMessage="Pilih Jabatan"
                                                        options={this.state.empOptionPosition} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih Pejabat Penilai"
                                                        defaultValue={this.state.detail_employee?.atasan?.employee_current_position_uuid}
                                                        onChange={(e)=>this.set_jabatanAtasan(e)}
                                                    />
                                                    <br />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_position"
                                                        id="skp_header_head_valuer_employee_position"
                                                        // readonly="readonly"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.jabatanAtasan}
                                                    />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_period_head_boss_employee_position_uuid"
                                                        id="skp_period_head_boss_employee_position_uuid"
                                                        // readonly="readonly"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.jabatanAtasan_uuid}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label
                                                    className="col-md-2 col-form-label"
                                                >
                                                Unit Kerja
                                                </label>
                                                <Col md="6">
                                                <CustomSelect 
                                                        name="atasan_unit"
                                                        errorMessage="Pilih Unit Kerja"
                                                        options={this.state.empOptionWorkunit} 
                                                        validate={{ required: { value: true } }}
                                                        placeholder="Pilih Unit Kerja"
                                                        defaultValue={(this.state.unit_detail_boss_uuid)?this.state.unit_detail_boss_uuid:this.state.detail_employee?.atasan?.work_unit_uuid}
                                                        onChange={(e)=>this.set_unitAtasan(e)}
                                                    />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_work_unit"
                                                        id="skp_header_head_valuer_employee_work_unit"
                                                        // readonly="readonly"
                                                        type="hidden"
                                                        className="form-control"
                                                        value={this.state.workunitAtasan}
                                                    />
                                                    <AvField
                                                        placeholder=""
                                                        name="skp_header_head_valuer_employee_work_unit_uuid"
                                                        readonly="readonly"
                                                        type="hidden"
                                                        value={this.state.workunitAtasan_uuid}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                            

                                        <hr />
                                        
                                        <Row>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/skp.html?data&euuid=${this.queryParams.get('euuid')}`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.message ?? "Data gagal disimpan"}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/skp.html?data&euuid=${this.queryParams.get('euuid')}`}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView